module.exports = __webpack_public_path__ + "static/media/usa-flag.d8ba0fb2.png";